import "./App.css";
import { createTheme, responsiveFontSizes, ThemeProvider } from "@mui/material";
import HomePage from "./pages/homePage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { colors } from "./utilities/colors";

function App() {
  let theme = createTheme({
    shape: {
      borderRadius: 24,
    },
    typography: {
      fontFamily: "Inter, Montserrat, sans-serif",
      h1: { fontFamily: "Outfit, sans-serif", fontWeight: 700 },
      h2: { fontFamily: "Outfit, sans-serif", fontWeight: 700 },
      h3: { fontFamily: "Outfit, sans-serif", fontWeight: 600 },
      h4: { fontFamily: "Outfit, sans-serif", fontWeight: 600 },
      button: { fontFamily: "Outfit, sans-serif", fontWeight: 600, textTransform: 'none' },
    },
    palette: {
      mode: "dark",
      primary: {
        main: "#22d3ee", // Cyan
      },
      secondary: {
        main: "#818cf8", // Purple
      },
      background: {
        default: "#020617",
        paper: "rgba(255, 255, 255, 0.03)",
      },
    },
  });
  theme = responsiveFontSizes(theme);
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
